var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
var mermaidInitialized = false;
/**
 * `mermaid.initialize()` is global config, not per-render — do it once, lazily, the
 * first time a diagram actually needs to be drawn (not at module load, so a page
 * that never shows a diagram never touches the `mermaid` global at all).
 */
function ensureMermaidInitialized() {
    if (mermaidInitialized)
        return;
    mermaidInitialized = true;
    // 'strict' sanitizes label/click content rather than trusting it as HTML — diagram
    // source here ultimately comes from an LLM reply, not a trusted author.
    mermaid.initialize({ startOnLoad: false, securityLevel: 'strict' });
}
var renderSeq = 0;
var MermaidBlock = /** @class */ (function (_super) {
    __extends(MermaidBlock, _super);
    function MermaidBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.error = null;
        return _this;
    }
    MermaidBlock.prototype.mounted = function () {
        this.build();
    };
    MermaidBlock.prototype.build = function () {
        var _this = this;
        ensureMermaidInitialized();
        var el = this.$refs.container;
        if (!el)
            return;
        var id = 'aimo-mermaid-' + ++renderSeq;
        mermaid
            .render(id, this.spec)
            .then(function (result) {
            // The component may have switched to the error view (or been
            // destroyed) while the render promise was pending.
            var target = _this.$refs.container;
            if (!target)
                return;
            target.innerHTML = result.svg;
            if (result.bindFunctions)
                result.bindFunctions(target);
        })
            .catch(function () {
            _this.error = _this.errorText;
        });
    };
    __decorate([
        Prop({ type: String, required: true })
    ], MermaidBlock.prototype, "spec", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], MermaidBlock.prototype, "errorText", void 0);
    MermaidBlock = __decorate([
        Component
    ], MermaidBlock);
    return MermaidBlock;
}(Vue));
export default MermaidBlock;
